<template>
  <div>
    <div class="row mobile-row-nogutters">
      <div class="col-12 col-md-6 col-xl-4 col-xl2-3">
        <crane-card :id="$route.params.id" :device-id="deviceId" />
      </div>
    </div>
  </div>
</template>

<script>

import CraneCard from '@/Main/CraneCard.vue';

export default
{
    computed:
    {
        deviceId()
        {
            const decoded = JSON.parse(atob(this.$route.params.id));
            return decoded[1];
        }
    },
    components: {CraneCard}
}
</script>

<style>
</style>